<template>
	<div class="review-analysis-modal">
		<managing-section>
			<managing-box title="리뷰">
				<p class="review-analysis-modal__review">{{ review }}</p>
			</managing-box>
			<managing-box title="키워드">
				<ul
					class="review-analysis-modal__keyword-list"
					v-if="keywordList.length > 0"
				>
					<li
						class="review-analysis-modal__keyword-item"
						v-for="(item, idx) in keywordList"
						:key="idx"
					>
						<p class="btn review-analysis-modal__keyword">
							{{ item }}
						</p>
					</li>
				</ul>
			</managing-box>
		</managing-section>
		<div class="review-analysis-modal__result-list">
			<div class="review-analysis-modal__result">
				<managing-section
					class="review-analysis-modal__result__section"
				>
					<review-analysis-result
						:positive-dict-items="positiveDictItems"
						:negative-dict-items="negativeDictItems"
						:undefined-dict-items="undefinedDictItems"
						:custom-dict-from-list="getCustomFromList"
						:positive-dict-from-list="getPositiveFromList"
						:negative-dict-from-list="getNegativeFromList"
					/>
				</managing-section>
				<button
					class="btn-main blue review-analysis-modal__result__apply-btn"
					type="button"
					@click="apply"
				>
					적용
				</button>
			</div>
			<div class="review-analysis-modal__list">
				<managing-section :is-table="true">
					<table class="table-main">
						<thead>
							<tr>
								<th v-for="(th, idx) in thList" :key="idx">
									{{ th }}
								</th>
							</tr>
						</thead>
						<tbody>
							<tr
								:class="{
									'review-analysis-modal__table__row--first-linked':
										item.isFirstLink,
									'review-analysis-modal__table__row--linked':
										item.isLinked,
								}"
								v-for="item in reviewList"
								:key="item.orderNum"
							>
								<td class="white-space__nowrap">
									{{ item.orderNum + 1 }}
								</td>
								<td>
									{{
										`${item.value}${item.isFirstLink ? ' (연결어 시작)' : ''}`
									}}
								</td>
								<td>{{ item.word }}</td>
								<td>{{ item.radix }}</td>
								<td
									class="white-space__nowrap review-analysis-modal__ty"
								>
									<RadioList
										:value="item.ty"
										:radio-list="tyList"
										:disabled="!item.isLinked || 'all'"
										@input="
											changeTy(
												$event,
												item.orderNum,
												item.isFirstLink
											)
										"
									/>
								</td>
								<td class="white-space__nowrap">
									<label
										class="review-analysis-modal__link-check-box"
										v-if="item.orderNum !== 0"
									>
										<input
											class="review-analysis-modal__link-check-box__input"
											type="checkbox"
											@change="
												changeIsLinked(
													item.isLinked,
													item.orderNum
												)
											"
											v-model="item.isLinked"
										/>
										<span
											class="review-analysis-modal__link-check-box__text"
											>연결 {{ item.orderNum }}</span
										>
									</label>
								</td>
								<td class="review-analysis-modal__table__dict">
									<input
										@keypress.enter="
											enterDict(item.orderNum, $event)
										"
										type="text"
										placeholder="단어로 등록(ex. 단어 + Enter)"
									/>
									<div
										class="review-analysis-modal__table__dict-list"
										v-show="item.dictList.length > 0"
									>
										<button
											class="btn-delete"
											type="button"
											v-for="(dict, idx) in item.dictList"
											:key="`${idx}${dict}`"
											@click="
												deleteDict(item.orderNum, idx)
											"
										>
											{{ dict }}
										</button>
									</div>
								</td>
							</tr>
						</tbody>
					</table>
				</managing-section>
			</div>
		</div>
	</div>
</template>

<script>
	import { mapState } from 'vuex';
	import ManagingSection from '@/components/layout/ManagingSection.vue';
	import ManagingBox from '@/components/layout/ManagingBox.vue';
	import RadioList from '@/components/RadioList';
	import ReviewAnalysisResult from '@/components/review/ReviewAnalysisResult.vue';

	export default {
		name: 'ReviewAnalysis',
		components: {
			ManagingSection,
			ManagingBox,
			RadioList,
			ReviewAnalysisResult,
		},
		data() {
			return {
				review: '',
				thList: [
					'',
					'텍스트',
					'단어',
					'어근',
					'긍부정 선택',
					'연결하기',
					'단어 등록',
				],
				reviewList: [],
				tyList: [
					{ id: null, value: '?' },
					{ id: 'positive', value: '긍정' },
					{ id: 'negative', value: '부정' },
				],
				positiveDictItems: [],
				negativeDictItems: [],
				undefinedDictItems: [],
				idProduct: null,
				idreviewcomment: null,
			};
		},
		computed: {
			...mapState({
				data: state => state.modal.params.data,
				keywordList: state => state.modal.params.keywordList,
			}),
			parsedReview() {
				return this.review.join(' ');
			},
			getCustomFromList() {
				return this.reviewList.reduce((acc, item) => {
					acc = [...acc, ...item.dictList];
					return acc;
				}, []);
			},
			getPositiveFromList() {
				return this.reviewList.reduce((acc, item) => {
					if (item.ty === 'positive') {
						if (item.isLinked) {
							acc[acc.length - 1].push(item.value);
						} else {
							acc.push([item.value]);
						}
					}
					return acc;
				}, []);
			},
			getNegativeFromList() {
				return this.reviewList.reduce((acc, item) => {
					if (item.ty === 'negative') {
						if (item.isLinked) {
							acc[acc.length - 1].push(item.value);
						} else {
							acc.push([item.value]);
						}
					}
					return acc;
				}, []);
			},
		},
		created() {
			this.setData();
		},
		methods: {
			enterDict: _.debounce(function (orderNum, e) {
				const dict = e.target.value;
				if (
					this.reviewList[orderNum].dictList.some(
						item => item === dict
					)
				) {
					alert('중복되는 단어가 있습니다');
					return;
				} else {
					this.reviewList[orderNum].dictList.push(dict);
					e.target.value = '';
				}
			}, 100),
			deleteDict(orderNum, dictIdx) {
				const dictList = this.reviewList[orderNum].dictList;
				this.reviewList[orderNum].dictList = dictList.filter(
					(item, idx) => idx !== dictIdx
				);
			},
			changeTy(id, orderNum, isFirstLink) {
				let limit = false;
				this.reviewList = this.reviewList.map(item => {
					if (item.orderNum === orderNum) {
						item.ty = id;
					} else if (isFirstLink && item.orderNum > orderNum) {
						if (!item.isLinked) limit = true;
						if (!limit) item.ty = id;
					}
					return item;
				});
			},
			changeIsLinked(id, orderNum) {
				this.reviewList = this.reviewList.map(item => {
					if (item.orderNum === orderNum - 1) {
						if (item.isLinked === false) item.isFirstLink = true;
						if (id === false) item.isFirstLink = false;
					} else if (item.orderNum === orderNum) {
						item.isLinked = id;
						item.isFirstLink =
							id === false &&
							this.reviewList[orderNum].isLinked === true;
					}
					return item;
				});
				const linkedOrderNumList =
					id === true
						? this.reviewList
								.filter(
									item =>
										item.isFirstLink &&
										item.orderNum < orderNum
								)
								.map(item => item.orderNum)
						: [];
				if (linkedOrderNumList.length > 0) {
					const firstLinkOrderNum = linkedOrderNumList.reduce(
						(acc, curr) => (acc > curr ? acc : curr)
					);
					let limit = false;
					this.reviewList = this.reviewList.map(item => {
						if (firstLinkOrderNum < item.orderNum) {
							if (item.isLinked === false) limit = true;
							if (limit === false)
								item.ty = this.reviewList[firstLinkOrderNum].ty;
						}
						return item;
					});
				}
			},
			setData() {
				const data = this.data;
				this.idProduct = data.idProduct;
				this.idreviewcomment = data.idreviewcomment;
				const positiveDictItems = (this.positiveDictItems =
					data.positiveDictItems);
				const negativeDictItems = (this.negativeDictItems =
					data.negativeDictItems);
				const undefinedDictItems = (this.undefinedDictItems =
					data.undefinedDictItems);
				const dictItems = [
					...positiveDictItems,
					...negativeDictItems,
					...undefinedDictItems,
				];
				this.review = this.data.reviewText.join(' ');
				this.reviewList = this.data.reviewText.map((value, idx) => {
					const row = {
						value,
						orderNum: idx,
						ty: null,
						isLinked: false,
						isFirstLink: false,
						dictList: [],
					};
					const obj = this.data.textAnalysis[value][0];
					if (obj.isWord) {
						row.word = obj.value;
						row.radix = '';
					} else if (obj.tag === 'XR') {
						row.word = '';
						row.radix = obj.value;
					} else {
						row.word = '';
						row.radix = '';
					}
					return row;
				});
				dictItems.forEach(item => {
					const idx = item.orderNum;
					if (item.isCustom) {
						this.reviewList[item.orderNum].dictList.push(
							item.value
						);
					} else if (item.isLinked) {
						item.value.split(' ').forEach((value, valueIdx) => {
							this.reviewList[valueIdx + idx].ty = item.ty;
							if (valueIdx === 0) {
								this.reviewList[valueIdx + idx].isFirstLink =
									true;
							} else {
								this.reviewList[valueIdx + idx].isLinked = true;
							}
						});
					} else {
						this.reviewList[idx].ty =
							item.ty === 'undefined' ? null : item.ty;
					}
				});
			},
			async apply() {
				try {
					const dictItems = this.reviewList.reduce((acc, item) => {
						if (item.dictList.length > 0) {
							item.dictList.forEach(dict => {
								acc.push({
									ty: item.ty || 'undefined',
									value: dict,
									isLinked: false,
									isCustom: true,
									orderNum: item.orderNum,
								});
							});
						}
						if (item.ty) {
							if (item.isLinked) {
								acc[acc.length - 1].value += ` ${item.value}`;
							} else {
								acc.push({
									ty: item.ty || 'undefined',
									value: item.value,
									isLinked: item.isFirstLink
										? true
										: item.isLinked,
									isCustom: item.isCustom || false,
									orderNum: item.orderNum,
								});
							}
						}
						return acc;
					}, []);
					const params = {
						reviewText: this.review,
						dictItems,
					};
					await this.$axiosAdmin2.post(
						`/api/analysis/reviews/product/${this.idProduct}/review/${this.idreviewcomment}/dict`,
						params
					);
					window.location.reload();
				} catch (err) {
					console.error(err);
					alert('적용에 실패했습니다. 개발팀에 문의하세요.');
				}
			},
		},
	};
</script>

<style lang="scss">
	.review-analysis-modal__review {
		line-height: 16px;
	}

	.review-analysis-modal__keyword-list {
		font-size: 0;
	}

	.review-analysis-modal__keyword-item {
		display: inline-block;
		margin-left: 8px;
		font-size: 0.875rem;

		&:first-child {
			margin-left: 0;
		}
	}

	.review-analysis-modal__keyword {
		&:hover {
			cursor: default;
			border: solid 1px #acaeb4;
		}
	}

	.review-analysis-modal__table__row--first-linked {
		background: rgba(143, 188, 143, 0.5);
	}

	.review-analysis-modal__table__row--linked {
		background: lightgoldenrodyellow;
	}

	.review-analysis-modal__ty {
		text-align: left;
	}

	.review-analysis-modal__link-check-box {
		cursor: pointer;
		display: inline-block;
		padding: 7px 4px;
		border-radius: 4px;
		font-size: 0;

		&:hover {
			background: #f4f7fa;
		}

		&:active {
			background: #dfe6ee;
		}
	}

	.review-analysis-modal__link-check-box__input {
		cursor: pointer;
		vertical-align: middle;
		margin-right: 8px;
		font-size: 0.875rem;

		&:checked + .review-analysis-modal__link-check-box__text {
			font-weight: 700;
		}
	}

	.review-analysis-modal__link-check-box__text {
		vertical-align: middle;
		font-size: 0.875rem;
	}

	.review-analysis-modal__result-list:after {
		content: '';
		display: block;
		clear: both;
	}

	.review-analysis-modal__result {
		float: left;
		width: 20%;
		text-align: right;

		.review-analysis-modal__result__section {
			text-align: left;
		}

		.section__conts-wrap {
			display: block;
		}

		.review-analysis-modal__result__apply-btn {
			margin-top: 10px;
		}
	}

	.review-analysis-modal__list {
		float: left;
		width: 80%;
	}

	.review-analysis-modal__table__dict {
		text-align: left;
	}

	.review-analysis-modal__table__dict-list {
		margin-top: 8px;
	}
</style>
